export default __webpack_public_path__ + "static/media/online-limit.3873e32f.svg";